module.exports = __webpack_public_path__ + "img/shoulder-endomorph-female.3b349426.svg";